import { useMemo } from 'react';

import { useGetTotalAssets } from '@/features/Modals/hooks/useGetTotalAssets';
import { compareBigNumbers, subtractFixedDecimals } from '@/shared/utils/helpers';
import { useModal } from '@/features/Modals';

export const useMaxBalance = () => {
    const { modalProps } = useModal();

    const { balance: userBalance, totalDepositThreshold, decimals } = modalProps || {};

    const { asset } = useGetTotalAssets();

    return useMemo(() => {
        if (
            (!totalDepositThreshold && totalDepositThreshold !== '0') ||
            (!asset && asset !== '0')
        ) {
            return null;
        }

        const limit = subtractFixedDecimals(totalDepositThreshold as string, asset!, decimals);
        return compareBigNumbers(userBalance, limit, decimals) < 0 ? userBalance : limit;
    }, [decimals, userBalance, totalDepositThreshold, asset]);
};
